import React from "react";

import Link from "next/link";

import { FaPlay } from "react-icons/fa";

import { IGroup } from "pages/[tenant]/g/@types";
import { GroupImage } from "pages/[tenant]/g/[group_slug]/moderation/components/Nexus/components/atoms/GroupImage";

import { OptionArrowIcon } from "shared/providers/Layout/components/NewTopBar/assets/OptionArrowIcon";
import { ILesson } from "shared/providers/context/types/NewGlobalSearch";

import { CardContainer } from "./styles";

interface ICardProps {
  onClick?: () => void;
  item: IGroup & ILesson;
}

export const Card = ({ onClick, item }: ICardProps) => {
  const isLesson = !!item?.group_topic_slug;

  const lessonImage =
    item?.thumbnail ?? item?.player?.thumbnail ?? item?.group?.logo_horizontal;
  const lessonUrl = `/g/${item?.group_slug}/classwork/${item?.group_topic_slug}/${item?.slug}`;

  const image = isLesson && !!lessonImage ? lessonImage : item?.logo_horizontal;
  const linkUrl = isLesson ? lessonUrl : `/g/${item?.slug}`;

  const groupColor = isLesson
    ? item?.group?.primary_color
    : item?.primary_color;

  return (
    <CardContainer isLesson={isLesson}>
      <Link
        href={linkUrl}
        onClick={onClick}
        title={item?.title}
        prefetch={false}
      >
        <div className="image-container">
          {isLesson && (
            <div className="player-icon">
              <FaPlay />
            </div>
          )}
          <GroupImage
            width={318}
            height={178}
            logoHorizontal={image}
            primaryColor={groupColor}
          />
        </div>
      </Link>
      <p className="title">{item?.title}</p>
      {isLesson && <p className="group-title">{item?.group?.title}</p>}
    </CardContainer>
  );
};
